import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FolderShared"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 6H21C21.8284 6 22.5 6.67157 22.5 7.5V19.5C22.5 20.3284 21.8284 21 21 21H3C2.17157 21 1.5 20.3284 1.5 19.5V4.5C1.5 3.67157 2.17157 3 3 3H8.3775C8.77728 2.99968 9.16065 3.15897 9.4425 3.4425L12 6ZM10.5 12.75C10.5 14.4069 11.8431 15.75 13.5 15.75C15.1569 15.75 16.5 14.4069 16.5 12.75C16.5 11.0931 15.1569 9.75 13.5 9.75C11.8431 9.75 10.5 11.0931 10.5 12.75ZM13.5 11.25C14.3284 11.25 15 11.9216 15 12.75C15 13.5784 14.3284 14.25 13.5 14.25C12.6716 14.25 12 13.5784 12 12.75C12 11.9216 12.6716 11.25 13.5 11.25ZM10.5 19.5V18.75C10.5 18.3358 10.8358 18 11.25 18H15.75C16.1642 18 16.5 18.3358 16.5 18.75V19.5H10.5ZM18 19.5H21V7.5H11.3775L10.9425 7.0575L8.3775 4.5H3V19.5H9V18.75C9 17.5074 10.0074 16.5 11.25 16.5H15.75C16.9926 16.5 18 17.5074 18 18.75V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FolderShared.vue"]]);
